import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
// import ChiSiamo from './components/ChiSiamo';
// import Servizi from './components/Servizi';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import CookiePolicy from './components/CookiePolicy';
import TermsAndConditions from './components/TermsAndConditions';
import './index.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import CookieBanner from './components/CookieBanner';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-customGray flex flex-col items-center">
        <div className="w-full max-w-7xl">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              {/* <Route path="/chi-siamo" element={<ChiSiamo />} />
              <Route path="/servizi" element={<Servizi />} /> */}
              <Route path="/" element={<Hero />}/* element={
                <React.Fragment>
                  <ChiSiamo />
                  <Servizi />
                </React.Fragment>
              } */ />
            </Routes>
          </main>
          <Footer />
          <CookieBanner />
        </div>
        <a 
          href="https://wa.me/391234567890" 
          className="fixed bottom-10 right-4 bg-green-500 text-white p-4 rounded-full shadow-lg flex items-center justify-center"
          target="_blank" 
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faWhatsapp} size="2x" />
        </a>
      </div>
    </Router>
  );
}

export default App;
